// Generated typography tokens
// This file is auto-generated. Do not edit manually.
// Fetched from Figma and transformed to TypeScript

export type FontWeight = 400 | 900 | 800

export type FontsAccessPaths = 'body' | 'monospace'

export const fonts = { monospace: '"IBM Plex Mono"', body: '"Adverity", "Adverity Fallback"' } satisfies Record<
    string,
    string
>
